import type { CalibratedPoint } from "./tracking.ts";

export type GameTarget = {
  id: string;
  x: number;
  y: number;
  cue: string;
};

export const ORBIT_TARGETS: GameTarget[] = [
  { id: "left-soft", x: -0.62, y: -0.08, cue: "慢慢看向左侧" },
  { id: "right-soft", x: 0.62, y: -0.08, cue: "慢慢看向右侧" },
  { id: "up-soft", x: 0, y: -0.62, cue: "轻轻抬头" },
  { id: "down-soft", x: 0, y: 0.58, cue: "轻轻低头" },
  { id: "left-up", x: -0.48, y: -0.46, cue: "向左上方移动" },
  { id: "right-down", x: 0.48, y: 0.44, cue: "向右下方移动" },
  { id: "right-up", x: 0.48, y: -0.46, cue: "向右上方移动" },
  { id: "left-down", x: -0.48, y: 0.44, cue: "向左下方移动" },
];

export const TARGET_DWELL_MS = 650;
export const TARGET_RADIUS = 0.27;

export function targetDistance(point: CalibratedPoint, target: GameTarget) {
  return Math.hypot(point.x - target.x, point.y - target.y);
}

export function targetReached(point: CalibratedPoint, target: GameTarget) {
  return targetDistance(point, target) <= TARGET_RADIUS;
}

export const BOAT_PATH: CalibratedPoint[] = [
  { x: 0, y: 0 },
  { x: -0.5, y: -0.08 },
  { x: -0.36, y: -0.42 },
  { x: 0.08, y: -0.5 },
  { x: 0.52, y: -0.2 },
  { x: 0.48, y: 0.28 },
  { x: 0.08, y: 0.48 },
  { x: -0.42, y: 0.3 },
  { x: -0.48, y: 0.02 },
  { x: 0, y: 0 },
];

export function pointAlongPath(points: CalibratedPoint[], progress: number) {
  if (points.length === 0) return { x: 0, y: 0 };
  if (points.length === 1) return points[0];
  const clamped = Math.min(1, Math.max(0, progress));
  const position = clamped * (points.length - 1);
  const index = Math.min(points.length - 2, Math.floor(position));
  const fraction = position - index;
  return {
    x: points[index].x + (points[index + 1].x - points[index].x) * fraction,
    y: points[index].y + (points[index + 1].y - points[index].y) * fraction,
  };
}

export const GREENHOUSE_TARGETS: GameTarget[] = [
  { id: "sun-right", x: 0.55, y: -0.1, cue: "看看右侧的阳光" },
  { id: "rain-up", x: 0, y: -0.55, cue: "轻轻抬头迎接雨滴" },
  { id: "wind-left", x: -0.55, y: -0.1, cue: "看看左侧的微风" },
  { id: "leaf-right-down", x: 0.4, y: 0.4, cue: "看看右下方的新叶" },
  { id: "bud-left-down", x: -0.4, y: 0.4, cue: "看看左下方的花苞" },
  { id: "light-up", x: 0, y: -0.55, cue: "轻轻抬头迎接晨光" },
];
